/* Kitap duvarı (sections/rs-wall.liquid): durdur/oynat düğmesi ve ekran dışında durma.
   Hareket CSS'tedir; bu dosya yalnız .is-paused ve .is-off sınıflarını açıp kapatır.
   Seçim oturum boyunca hatırlanır (sessionStorage): duran duvar yeni sayfada akmaya başlamaz. */
(function () {
  'use strict';
  var KEY = 'rs-wall-paused';
  function init(wall) {
    if (wall.rsWallReady) return;
    wall.rsWallReady = true;
    var btn = wall.querySelector('[data-rs-wall-pause]');
    var text = wall.querySelector('[data-rs-wall-pause-text]');
    var set = function (paused) {
      wall.classList.toggle('is-paused', paused);
      if (!btn) return;
      btn.setAttribute('aria-pressed', String(paused));
      var label = btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause') || '';
      if (text) text.textContent = label;
      btn.setAttribute('aria-label', label);
    };
    var stored = false;
    try { stored = window.sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    set(stored);
    if (btn) {
      btn.addEventListener('click', function () {
        var next = !wall.classList.contains('is-paused');
        set(next);
        try { window.sessionStorage.setItem(KEY, next ? '1' : '0'); } catch (e) {}
      });
    }
    /* Ekran dışındayken akış durur (pil ve işlemci) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { wall.classList.toggle('is-off', !entry.isIntersecting); });
      }).observe(wall);
    }
  }
  function run() { document.querySelectorAll('[data-rs-wall]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
